import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchMessages, updateMessage, setMessagesPaging } from '../../action/messages';
import moment from 'moment';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';
import ErrorContainer from '../../components/utils/ErrorContainer';

export class SendedMessage extends Component {
    componentDidMount() {
        this.getMessages();
    }

    state = {
        currentPage: 0
    }

    componentWillUnmount() {
        const { paging } = this.props;
        this.props.setMessagesPaging({ ...paging, start: 0 });
    }

    getMessages = () => {
        this.props.fetchMessages({ status: 'sended' });
    }

    deleteMessage = (id) => {
        swal({
            title: "Удаление сообщения",
            text: "Вы действительно хотите удалить сообщение?",
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                this.props.updateMessage(id, { status: 'deleted' }).then(result => {
                    if (result) {
                        this.getMessages();
                    }
                })
            }
        });
    }

    renderMessage = (item) => {
        return (
            <div key={item.id} className="kt-inbox__item kt-inbox__item--unread" data-id="1" data-type="inbox" style={item.status === 'unsended' ? { backgroundColor: '#fff0f0' } : {}}>
                <div className="kt-inbox__info">
                    <div className="kt-inbox__sender" data-toggle="view">
                        <div href="/" className="kt-inbox__author">{item.theme}</div>
                        {window.innerWidth <= 530 && <div onClick={() => this.deleteMessage(item.id)} className="deleteIcon">
                            <i className="la la-close"></i>
                        </div>}
                    </div>
                </div>
                {window.innerWidth <= 530 && <div className="kt-inbox__datetime" data-toggle="view">
                    {item.time ? moment(item.time).format('DD.MM.YYYY HH:mm') : ''}
                </div>}
                {window.innerWidth <= 530 && <div className="kt-inbox__datetime" data-toggle="view">
                    {moment(item.created_at).format('DD.MM.YYYY HH:mm')}
                </div>}
                <div className="kt-inbox__details" data-toggle="view">
                    <div className="kt-inbox__message">
                        <span className="kt-inbox__summary">{item.message}</span>
                    </div>
                    <div className="kt-inbox__labels">
                        {
                            item.chanels.map(chanel => {
                                if (chanel.key === 'user' || chanel.key === 'bonus') {
                                    return (
                                    <span className="kt-inbox__label kt-badge kt-badge--unified-brand kt-badge--dark kt-badge--bold kt-badge--inline">{chanel.title}: {chanel.value.phone}</span>
                                    );
                                }
                                if (chanel.key === 'users') {
                                    return (
                                    <span className="kt-inbox__label kt-badge  kt-badge--success kt-badge--bold kt-badge--inline">{chanel.title}</span>
                                    );
                                }
                                if (chanel.key === 'all') {
                                    return (
                                    <span className="kt-inbox__label kt-badge  kt-badge--danger kt-badge--bold kt-badge--inline">{chanel.title}</span>
                                    );
                                }
                                if (chanel.key === 'city') {
                                    return (
                                        <span className="kt-inbox__label kt-badge kt-badge--warning kt-badge--bold kt-badge--inline">{chanel.title}</span>
                                    );
                                }
                                return (
                                    <span className="kt-inbox__label kt-badge kt-badge--dark kt-badge--bold kt-badge--inline">{chanel.title}</span>
                                );
                            })
                        }
                    </div>
                </div>
                {window.innerWidth > 530 &&<div className="kt-inbox__datetime" data-toggle="view">
                    {item.time ? moment(item.time).format('DD.MM.YYYY HH:mm') : ''}
                </div>}
                {window.innerWidth > 530 && <div className="kt-inbox__datetime" data-toggle="view">
                    {moment(item.created_at).format('DD.MM.YYYY HH:mm')}
                </div>}
                {window.innerWidth > 530 && <div onClick={() => this.deleteMessage(item.id)} className="deleteIcon">
                    <i className="la la-close"></i>
                </div>}
            </div>
        );
    }

    setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { start: 0, limit: e.target.value};
        this.setState({ currentPage: 0 });
        this.props.setMessagesPaging(updatedPaging);
        this.getMessages();
    }

    handlePageClick = data => {
        const { paging } = this.props;
        this.setState({ currentPage: data.selected }, () => {
            let nextStart =  data.selected * paging.limit;
            const updatedPaging = {...paging, start: nextStart};
            this.props.setMessagesPaging(updatedPaging);
            this.getMessages();
        });
    };

    chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 400)
            return 1;

        if(userDisplayWidth < 550)
            return 2;

        if(userDisplayWidth < 850)
            return 3;

        if(userDisplayWidth < 1250)
            return 5;

        return 8;
    }

    chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 550)
            return 2;

        if(userDisplayWidth < 850)
            return 3;

        return 5;
    }

    renderPagination() {
        const { count, paging } = this.props;
        const pages = Math.ceil(+count / +paging.limit);

        return (
            <div className="kt-datatable kt-datatable--default">
            <div className="kt-datatable__pager kt-datatable--paging-loaded">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={this.chekMarginPagesDisplayed()}
                    pageRangeDisplayed={this.chekPageRangeDisplayed()}
                    forcePage={this.state.currentPage}
                    onPageChange={this.handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={this.setPageLimit} value={paging.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + paging.limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +paging.limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
            </div>
        );
    }
    
    render() {
        return (
            <div className="kt-grid__item kt-grid__item--fluid    kt-portlet    kt-inbox__list kt-inbox__list--shown" id="kt_inbox_list" style={{ display: 'flex' }}>
                
                <div className="kt-portlet__head">
                    <div className="kt-inbox__toolbar kt-inbox__toolbar--extended">
                        <div className="kt-inbox__actions kt-inbox__actions--expanded">
                            <div className="kt-inbox__check">
                            <h5 style={{ marginBottom: 0 }}>Отправленные уведомления ({this.props.count})</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div className="kt-inbox__items" data-type="inbox">
                        { this.props.messages.map(this.renderMessage) }
                    </div>
                    {
                            this.props.messages.length > 0 && this.renderPagination()
                    }
                </div>
                <ErrorContainer field="messages" style={{ margin: 15 }} hasCloseButton={false}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    messages: state.messages.sended.list,
    count: state.messages.sended.count,
    paging: state.messages.sended.paging
})

const mapDispatchToProps = {
    fetchMessages: (params) => fetchMessages('sended', params),
    updateMessage: (id, data) => updateMessage(id, data),
    setMessagesPaging: (paging) => setMessagesPaging('sended', paging)
}

export default connect(mapStateToProps, mapDispatchToProps)(SendedMessage)
